import { Link, NavLink } from 'react-router-dom'
import africasaLogo from '../../assets/africasa-logo.png'
import { LogoutOutlined, UserOutlined } from "@ant-design/icons"


const SidebarLayout = (props) => {
    return (
        <div
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-africasa-primary text-white transform ${
          props.sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform lg:translate-x-0 lg:static lg:inset-0`}
      >
        <div className="flex items-center justify-center h-16 border-b bg-white">
            <img src={africasaLogo} className='w-32 m-auto mb-6' alt='Africasa Auto logo'></img>

          {/* <h1 className="text-2xl font-semibold">Admin Dashboard</h1> */}
        </div>
        <nav className="p-4 space-y-2  bg-africasa-primary">
          <Link to="/" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Accueil
          </Link>
          <Link to="/gestion-prestataires/liste" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des vendeurs
          </Link>
          <Link to="/gestion-clients/liste" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des Clients
          </Link>
          {/* <Link to="/gestion-rdv/liste" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des Rendez-vous
          </Link> */}


          <Link to="/gestion-admins/liste" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des administrateurs
          </Link>

          <hr className="border  mb-2"></hr>
            <p className='text-center'>DEVISES</p>
          <hr className="border  mb-2"></hr>
          <Link to="/devises" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des devises
          </Link>

          <hr className="border  mb-2"></hr>
            <p className='text-center'>PAYS</p>
          <hr className="border  mb-2"></hr>
          <Link to="/pays" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des pays
          </Link>

          <hr className="border  mb-2"></hr>
            <p className='text-center'>ANNONCES</p>
          
          <hr className="border  mb-2"></hr>
          <Link to="/annonces/categories" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des categories d'annonces
          </Link>

          <Link to="/annonces" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des annonces
          </Link>
          <Link to="/commandes" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des commandes
          </Link>
          {/* <Link to="/factures" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Gestion des factures
          </Link> */}

           <Link to="/commission" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Commission
          </Link>
          <hr className="border  mb-2"></hr>
            <p className='text-center'>JURIDIQUE</p>
          <hr className="border  mb-2"></hr>
          <Link to="/conditions-generales" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Conditions Générales
          </Link>
          

          <hr className="border  mb-2"></hr>
            <p className='text-center'>ABONNEMENTS</p>
          <hr className="border  mb-2"></hr>

          <Link to="/frais-abonnements" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Frais d'abonnement
          </Link>

          <hr className="border  mb-2"></hr>
            <p className='text-center'>ANITA</p>            
          
          <hr className="border  mb-2"></hr>
          <Link to="/formations" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Formations
          </Link>

          <hr className="border  mb-2"></hr>
          <Link to="/parametres" className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Paramètres
          </Link>
          
          


          <button className="text-gray-100 font-medium bg-transparent"><LogoutOutlined onClick={props.handleLogout}/> Deconnexion</button>



          {/* <a href="javascript:void(0)" onClick={props.handleLogout} className="block p-2 text-sm text-gray-300 rounded hover:bg-africasa-secondary">
            Deconnexion
          </a> */}
        </nav>
      </div>
    )
}

export default SidebarLayout